import { Flex } from 'antd';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { cn } from '../lib/cn';

const CustomNavigationItem = ({
  icon,
  path,
  isActive,
  label,
  classNames,
  onClick,
}: {
  path?: string;
  label: string;
  icon: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  classNames?: { button?: string; icon?: string; label?: string };
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (path) navigate(path);
    if (onClick) onClick();
  };

  // Normal navigation item
  return (
    <Menu
      {...{ icon, path, isActive, label, classNames, onClick }}
      onClick={handleNavigate}
    />
  );
};

type MenuProps = {
  label: string;
  icon: ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  classNames?: { button?: string; icon?: string; label?: string };
};

const Menu = ({ icon, label, isActive, onClick, classNames }: MenuProps) => {
  return (
    <div
      onClick={onClick}
      data-selected={isActive}
      className={cn(
        'cursor-pointer group flex flex-col items-center justify-center gap-[9px]',
        'w-full min-h-[80px] py-2.5 px-[5px] rounded-lg transition-all duration-200',
        'dark:bg-theme-slate-800 border border-theme-gray-700 dark:border-theme-gray-700',
        'hover:dark:bg-theme-primary hover:dark:border-theme-primary hover:dark:text-theme-gray-650',
        'active:dark:bg-theme-primary active:dark:border-theme-primary active:dark:text-theme-gray-650',
        'data-[selected=true]:dark:bg-theme-primary data-[selected=true]:dark:border-theme-primary data-[selected=true]:dark:text-theme-gray-650',
        classNames?.button,
      )}
    >
      <Flex
        align="center"
        justify="center"
        className={cn(
          'size-[31px] rounded-full transition-all duration-200 text-xs',
          'bg-theme-slate-700 group-hover:bg-white group-data-[selected=true]:bg-white',
          classNames?.icon,
        )}
      >
        {icon}
      </Flex>
      <h6
        data-selected={isActive}
        className="font-medium data-[selected=true]:font-bold text-center"
      >
        {label}
      </h6>
    </div>
  );
};
export default CustomNavigationItem;
